import { render, staticRenderFns } from "./PlotList.vue?vue&type=template&id=4d4612c4&scoped=true&"
import script from "./PlotList.vue?vue&type=script&lang=js&"
export * from "./PlotList.vue?vue&type=script&lang=js&"
import style0 from "./PlotList.vue?vue&type=style&index=0&id=4d4612c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4612c4",
  null
  
)

export default component.exports